import { render } from "./Aboutus.vue?vue&type=template&id=bd7576ae&scoped=true"
import script from "./Aboutus.vue?vue&type=script&lang=js"
export * from "./Aboutus.vue?vue&type=script&lang=js"

import "./Aboutus.vue?vue&type=style&index=0&id=bd7576ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd7576ae"]])

export default __exports__